// src/auth/authConfig.js
import logger from '../utils/logger';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || 'demoClientID',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        logger.log(message);
      },
      piiLoggingEnabled: false,
      logLevel: 1
    }
  }
};

// Scopes for authentication
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"]
};

// Define the scopes for Business Central
export const businessCentralScopes = {
  // Using .default scope instead of individual scopes
  read: ["https://api.businesscentral.dynamics.com/.default"],
  readWrite: ["https://api.businesscentral.dynamics.com/.default"],
  api: ["https://api.businesscentral.dynamics.com/.default"]
};

// API backend configuration
export const apiConfig = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || "https://demo-backend-demo.uksouth-01.azurewebsites.net/api",
  validateTokenEndpoint: "/auth/validate-token",
  userEndpoint: "/user",
  bcEndpoint: "/bc"
};